import type { SVGProps } from 'react';
const SvgFormatTextdirectionRToL = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#format_textdirection_r_to_l_svg__a)">
      <path
        fill="currentColor"
        d="M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4Zm-2 7v-3l-4 4 4 4v-3h12v-2H8Z"
      />
    </g>
    <defs>
      <clipPath id="format_textdirection_r_to_l_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFormatTextdirectionRToL;
